/* eslint-disable */
export default {
  logged: 'Registado',
  unlogged: 'Não trabalhado',
  faxNotSupported: 'O registo de fax não é suportado.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
